import { Injectable } from '@angular/core';
import { UserInvestor } from './model/user-investor.model';
import { UserSignupDataService } from './user-signup-data.service';

@Injectable({
  providedIn: 'root',
})
export class UserSignupMockService implements UserSignupDataService {

  readonly responseUserSignup = {
    data: {
      code: 200
    }
  };

  postUserSignup(userData: UserInvestor): Promise<any> {
    return Promise.resolve(this.responseUserSignup);
  }

}
